import {
  ALL_STOCK_REQUESTING,
  ALL_STOCK_REQUEST_SUCCESS,
  ALL_STOCK_REQUEST_ERROR,
  SNAPSHOT_REQUESTING,
  SNAPSHOT_REQUEST_SUCCESS,
  SNAPSHOT_REQUEST_ERROR,
  STOCK_INFO_REQUEST_SUCCESS,
  ALL_ORD_REQUESTING,
  ALL_ORD_REQUEST_SUCCESS,
  ALL_ORD_REQUEST_ERROR,
  CLEAR_PART_REQUEST,
  CLEAR_SNAPSHOT_REQUEST,
  SNAPSHOT_PART_REQUESTING,
  SNAPSHOT_PART_REQUEST_SUCCESS,
  SNAPSHOT_PART_REQUEST_ERROR,
  PT_LIST_REQUEST_SUCCESS,
  PT_LIST_REQUESTING,
  PT_LIST_REQUEST_ERROR,
  CW_LIST_REQUESTING,
  CW_LIST_REQUEST_SUCCESS,
  CW_LIST_REQUEST_ERROR,
  LIST_30_REQUESTING,
  LIST_30_REQUEST_ERROR,
  LIST_30_REQUEST_SUCCESS,
  LIST_MESSAGE_REQUEST_ERROR,
  LIST_MESSAGE_REQUESTING,
  LIST_MESSAGE_REQUEST_SUCCESS,
  BRANCH_CODE_REQUESTING,
  BRANCH_CODE_REQUEST_ERROR,
  BRANCH_CODE_REQUEST_SUCCESS,
  SUMMARY_REQUESTING,
  SUMMARY_REQUEST_ERROR,
  SUMMARY_REQUEST_SUCCESS,
  NOI_CAP_REQUESTING,
  NOI_CAP_REQUEST_ERROR,
  NOI_CAP_REQUEST_SUCCESS,
  GET_STOCK_BY_ID_REQUESTING,
  GET_STOCK_BY_ID_REQUEST_SUCCESS,
  GET_STOCK_BY_ID_REQUEST_ERROR,
  INDEX_REQUESTING,
  INDEX_REQUEST_SUCCESS,
  INDEX_REQUEST_ERROR,
  WORLD_INDEX_REQUESTING,
  WORLD_INDEX_REQUEST_SUCCESS,
  WORLD_INDEX_REQUEST_ERROR,
  PS_LIST_REQUEST_SUCCESS,
  PS_LIST_REQUEST_ERROR,
  PS_LIST_REQUESTING,
  PS_SNAPSHOT_REQUEST_SUCCESS,
  PS_SNAPSHOT_REQUESTING,
  PS_SNAPSHOT_REQUEST_ERROR,
  NDATA_SNAPSHOT_REQUESTING,
  NDATA_SNAPSHOT_REQUEST_ERROR,
  NDATA_SNAPSHOT_REQUEST_SUCCESS,
  TRADE_HIS_PS_REQUESTING,
  TRADE_HIS_PS_REQUEST_SUCCESS,
  TRADE_HIS_PS_REQUEST_ERROR,
  TRADE_HIS_PS_Add_ROW,
  DM_NGANH_REQUESTING,
  DM_NGANH_REQUEST_SUCCESS,
  DM_NGANH_REQUEST_ERROR,
  LIST_ETF_REQUESTING,
  LIST_ETF_REQUEST_SUCCESS,
  LIST_ETF_REQUEST_ERROR,
  LOLE_SNAPSHOT_REQUEST_SUCCESS,
  LOLE_SNAPSHOT_REQUESTING,
  LOLE_SNAPSHOT_REQUEST_ERROR,
  SORT_TYPE,
  PS_INDEX_REQUEST_SUCCESS,
  SNAPSHOT_UNDERLYING_REQUESTING,
  SNAPSHOT_UNDERLYING_REQUEST_SUCCESS,
  SNAPSHOT_UNDERLYING_REQUEST_ERROR,
  MARGIN_LIST_REQUESTING,
  MARGIN_LIST_REQUEST_SUCCESS,
  MARGIN_LIST_REQUEST_ERROR,
  LOLE_HSX_SNAPSHOT_REQUEST_SUCCESS,
  LOLE_HSX_SNAPSHOT_REQUESTING,
  LOLE_HSX_SNAPSHOT_REQUEST_ERROR,
  TOP_INTEREST_REQUEST_ERROR,
  TOP_INTEREST_REQUEST_SUCCESS,
  TOP_VOLUME_REQUESTING,
  TOP_VOLUME_SUCCESS,
  BOND_LIST_REQUESTING,
  BOND_LIST_REQUEST_ERROR,
  BOND_LIST_REQUEST_SUCCESS,
} from './constants';

import * as _ from 'lodash'
import { StringToInt } from '../../utils';

const initialState = {
  allStock: [],
  allStockRequesting: false,
  allStockSuccessful: false,
  allStockErrors: [],

  listMessage: null,

  snapshot: [],
  snapshotRequesting: false,
  snapshotSuccessful: false,
  snapshotErrors: [],

  snapshotCW: [],
  snapshotBond: [],
  psSnapshot: [],
  psIndex: [],
  ndataSnapshot: null,
  tradeHisPs: [],

  part: [],
  partRequesting: false,
  partSuccessful: false,

  partId: [],
  partIdRequesting: false,
  partIdSuccessful: false,
  partIdErrors: [],

  allOrder: null,
  marginList: [],
  ptList: [],
  psList: [],
  lole: [],
  cwList: null,
  bondList: null,
  list30: null,
  listEtf: null,
  branchList: null,
  noicap: null,
  indSum: null,
  dmNganh: [],

  sort: [],

  indexList: [],
  worldList: [],
  requesting: false,
  successful: false,
  errors: [],
};

const reducer = function widgetReducer(state = initialState, action) {
  switch (action.type) {
    case ALL_STOCK_REQUESTING:
      return {
        ...state,
        allStockRequesting: false,
        allStockSuccessful: false,
        allStockErrors: [],
      };

    case ALL_STOCK_REQUEST_SUCCESS:
      return {
        ...state,
        allStock: action.allStock,
        allStockRequesting: false,
        allStockSuccessful: true,
        allStockErrors: [],
      };

    case ALL_STOCK_REQUEST_ERROR:
      return {
        ...state,
        allStockRequesting: false,
        allStockSuccessful: false,
        allStockErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case SNAPSHOT_REQUESTING:
      return {
        ...state,
        snapshotRequesting: true,
        snapshotSuccessful: false,
        snapshotErrors: [],
      };

    case SNAPSHOT_REQUEST_SUCCESS:
      return {
        ...state,
        snapshot: action.dataList, // replace with fresh list
        snapshotRequesting: false,
        snapshotSuccessful: true,
        snapshotErrors: [],
        lole: [],
        ptList: [],
        psSnapshot: [],
        tradeHisPs: null,
        ndataSnapshot: null,
        // cwList: null,
        partId: [],
      };

    case SNAPSHOT_REQUEST_ERROR:
      return {
        ...state,
        snapshotRequesting: false,
        snapshotSuccessful: false,
        snapshotErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case CLEAR_PART_REQUEST:
      return {
        ...state,
        part: [],
        partRequesting: false,
        partSuccessful: false,
      };

    case CLEAR_SNAPSHOT_REQUEST:
      return {
        ...state,
        snapshot: [],
        snapshotCW: [],
        snapshotBond: [],
        snapshotRequesting: false,
        snapshotSuccessful: false,
      };

    case SNAPSHOT_PART_REQUESTING:
      return {
        ...state,
        partRequesting: true,
        partSuccessful: false,
      };

    case SNAPSHOT_PART_REQUEST_SUCCESS:
      return {
        ...state,
        part: [...state.part, ...action.dataList], // replace with fresh list
        partRequesting: false,
        partSuccessful: true,
      };

    case SNAPSHOT_PART_REQUEST_ERROR:
      return {
        ...state,
        partRequesting: false,
        partSuccessful: false,
      };

    case STOCK_INFO_REQUEST_SUCCESS:
      return {
        ...state,
        snapshot: [...state.snapshot, ...action.stockInfo],
      };

    case ALL_ORD_REQUESTING:
    case ALL_ORD_REQUEST_ERROR:
      return {
        ...state,
        allOrder: null,
      };

    case ALL_ORD_REQUEST_SUCCESS:
      return {
        ...state,
        allOrder: action.allOrder,
      };

    case PT_LIST_REQUESTING:
    case PT_LIST_REQUEST_ERROR:
      return {
        ...state,
        ptList: [],
      };

    case PT_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        ptList: action.ptList,
      };

    case PS_LIST_REQUESTING:
    case PS_LIST_REQUEST_ERROR:
      return {
        ...state,
        psList: [],
      };

    case PS_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        psList: action.psList,
      };

      case LOLE_SNAPSHOT_REQUESTING:
      case LOLE_SNAPSHOT_REQUEST_ERROR:
      case LOLE_HSX_SNAPSHOT_REQUESTING:
      case LOLE_HSX_SNAPSHOT_REQUEST_ERROR:
      return {
        ...state,
        lole: [],
      };

      case LOLE_SNAPSHOT_REQUEST_SUCCESS:
      case LOLE_HSX_SNAPSHOT_REQUEST_SUCCESS:
      return {
        ...state,
        lole: action.dataList,
        ptList: [],
        psSnapshot: [],
        tradeHisPs: null,
        ndataSnapshot: null,
        cwList: null,
        bondList: null,
        snapshotCW: [],
        snapshotBond: [],
        snapshot: [],
        partId: [],
      };

    case PS_SNAPSHOT_REQUESTING:
    case PS_SNAPSHOT_REQUEST_ERROR:
      return {
        ...state,
        psSnapshot: [],
      };

    case PS_SNAPSHOT_REQUEST_SUCCESS:
      return {
        ...state,
        psSnapshot: action.dataList,
        lole: [],
        ptList: [],
        cwList: null,
        bondList: null,
        snapshotCW: [],
        snapshotBond: [],
        snapshot: [],
      };

    // case PS_INDEX_REQUESTING:
    // case PS_INDEX_REQUEST_ERROR:
    //   return {
    //     ...state,
    //     // psIndex: [],
    //   };

    case PS_INDEX_REQUEST_SUCCESS:
      return {
        ...state,
        psIndex: action.dataList,
      };

    case NDATA_SNAPSHOT_REQUESTING:
    case NDATA_SNAPSHOT_REQUEST_ERROR:
      return {
        ...state,
        ndataSnapshot: null,
      };

    case NDATA_SNAPSHOT_REQUEST_SUCCESS:
      return {
        ...state,
        ndataSnapshot: action.ndata,
      };

    case TRADE_HIS_PS_Add_ROW:
      const {data} = action
      const {tradeHisPs} = state
      const _tradeHis = _.isArray(tradeHisPs) ? [...tradeHisPs] : []
      const __tradeHis = _.concat([data], _tradeHis)
      return {
        ...state,
        tradeHisPs: __tradeHis,
      }

    case SORT_TYPE:
      const {_type} = action
      const {snapshot, partId} = state
      let _csData;

      // console.log(_type, snapshot, partId)
      if(!!snapshot.length) {
        if(_type && !!_type.length) {
          if (_type[0] === 'lot' 
              || _type[0] === 'fRoom' 
              || _type[0] === 'fBVol' 
              || _type[0] === 'fSVolume') {
            _csData = _.sortBy(snapshot, [
              function (obj) {
                return StringToInt(obj[_type[0]]);
              },
            ]);
          } else {
            _csData = _.sortBy(snapshot, [_type[0]]);
          }
          if (_type[1] !== 'asc') _csData = _csData.reverse();
        }
        
        return {
          ...state,
          snapshot: _csData,
        }
      }

      if(!!partId.length){
        if(_type && !!_type.length) {
          if (_type[0] === 'lot') {
            _csData = _.sortBy(partId, [
              function (obj) {
                return StringToInt(obj[_type[0]]);
              },
            ]);
          } else {
            _csData = _.sortBy(partId, [_type[0]]);
          }
          if (_type[1] !== 'asc') _csData = _csData.reverse();
        }
        
        return {
          ...state,
          partId: _csData,
        }
      }

    case TRADE_HIS_PS_REQUESTING:
    case TRADE_HIS_PS_REQUEST_ERROR:
      return {
        ...state,
        tradeHisPs: null,
      };

    case TRADE_HIS_PS_REQUEST_SUCCESS:
      return {
        ...state,
        tradeHisPs: action.dataList,
      };

    case CW_LIST_REQUESTING:
    case CW_LIST_REQUEST_ERROR:
      return {
        ...state,
        cwList: null,
        snapshotCW: [],
        snapshot: [],
      };

    case CW_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        cwList: action.cwList,
      };

    case BOND_LIST_REQUESTING:
    case BOND_LIST_REQUEST_ERROR:
      return {
        ...state,
        bondList: null,
        snapshotBond: [],
        snapshot: [],
      };
    
    case BOND_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        bondList: action.resData,
      };

    case LIST_30_REQUESTING:
    case LIST_30_REQUEST_ERROR:
      return {
        ...state,
        list30: null,
      };

    case LIST_30_REQUEST_SUCCESS:
      return {
        ...state,
        list30: action.list30,
      };

    case LIST_ETF_REQUESTING:
    case LIST_ETF_REQUEST_ERROR:
      return {
        ...state,
        listEtf: null,
      };

    case LIST_ETF_REQUEST_SUCCESS:
      return {
        ...state,
        listEtf: action.listEtf,
        lole: [],
        ptList: [],
        psSnapshot: [],
        tradeHisPs: null,
        ndataSnapshot: null,
        cwList: null,
        bondList: null,
        snapshotCW: [],
        snapshotBond: [],
        snapshot: [],
        partId: [],
      };

    case LIST_MESSAGE_REQUESTING:
    case LIST_MESSAGE_REQUEST_ERROR:
      return {
        ...state,
        listMessage: null,
      };

    case LIST_MESSAGE_REQUEST_SUCCESS:
      return {
        ...state,
        listMessage: action.listMessage,
      };

    case BRANCH_CODE_REQUESTING:
    case BRANCH_CODE_REQUEST_ERROR:
      return {
        ...state,
        branchList: null,
      };

    case BRANCH_CODE_REQUEST_SUCCESS:
      return {
        ...state,
        branchList: action.branchList,
      };

    case NOI_CAP_REQUESTING:
    case NOI_CAP_REQUEST_ERROR:
      return {
        ...state,
        noicap: null,
      };

    case NOI_CAP_REQUEST_SUCCESS:
      return {
        ...state,
        noicap: action.noicap,
      };

    case SUMMARY_REQUESTING:
    case SUMMARY_REQUEST_ERROR:
      return {
        ...state,
        indSum: null,
      };

    case SUMMARY_REQUEST_SUCCESS:
      return {
        ...state,
        indSum: action.indSum,
      };

    case DM_NGANH_REQUESTING:
    case DM_NGANH_REQUEST_ERROR:
      return {
        ...state,
        dmNganh: null,
      };

    case DM_NGANH_REQUEST_SUCCESS:
      return {
        ...state,
        dmNganh: action.dataList,
      };

    case TOP_INTEREST_REQUEST_ERROR:
      return {
        ...state,
        topInterest: null,
      };

    case TOP_INTEREST_REQUEST_SUCCESS:
      return {
        ...state,
        topInterest: action.dataList,
      };
      
    case TOP_VOLUME_REQUESTING:
      return {
        ...state,
        topVolume: null,
      };

    case TOP_VOLUME_SUCCESS:
      return {
        ...state,
        topVolume: action.resData,
      };


    case SNAPSHOT_UNDERLYING_REQUESTING:
    case SNAPSHOT_UNDERLYING_REQUEST_ERROR:
      return {
        ...state,
        snapshotCW: [],
      };

    case SNAPSHOT_UNDERLYING_REQUEST_SUCCESS:
      return {
        ...state,
        snapshotCW: action.dataList,
      };

    case MARGIN_LIST_REQUESTING:
    case MARGIN_LIST_REQUEST_ERROR:
      return {
        ...state,
        marginList: [],
      };

    case MARGIN_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        marginList: action.marginList,
      };

    case GET_STOCK_BY_ID_REQUESTING:
      return {
        ...state,
        partIdRequesting: true,
        partIdSuccessful: false,
        partIdErrors: [],
      };

    case GET_STOCK_BY_ID_REQUEST_SUCCESS:
      return {
        ...state,
        partId: action.dataList,
        partIdRequesting: false,
        partIdSuccessful: true,
        partIdErrors: [],
        listEtf: [],
        lole: [],
        ptList: [],
        psSnapshot: [],
        tradeHisPs: null,
        ndataSnapshot: null,
        cwList: null,
        bondList: null,
        snapshotCW: [],
        snapshotBond: [],
        snapshot: [],
      };

    case GET_STOCK_BY_ID_REQUEST_ERROR:
      return {
        ...state,
        partId: [],
        partIdRequesting: false,
        partIdSuccessful: false,
        partIdErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case INDEX_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        requesting: true,
        successful: false,
        errors: [],
      };

    case INDEX_REQUEST_SUCCESS:
      // console.log(action);
      return {
        ...state,
        indexList: action.indexList, // replace with fresh list
        requesting: false,
        successful: true,
        errors: [],
      };

    case INDEX_REQUEST_ERROR:
      return {
        ...state,
        requesting: false,
        successful: false,
        errors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case WORLD_INDEX_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        requesting: true,
        successful: false,
        errors: [],
      };

    case WORLD_INDEX_REQUEST_SUCCESS:
      return {
        ...state,
        worldList: action.worldList, // replace with fresh list
        requesting: false,
        successful: true,
        errors: [],
      };

    case WORLD_INDEX_REQUEST_ERROR:
      return {
        ...state,
        requesting: false,
        successful: false,
        errors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    default:
      return state;
  }
};

export default reducer;
